import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  getDoc,
  query,
  where,
  orderBy,
  onSnapshot
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { fighterService } from './fighterService';

export const fightService = {
  // Create a new fight
  async createFight(fightData) {
    const docRef = await addDoc(collection(db, 'fights'), {
      ...fightData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    return docRef.id;
  },


  // Update fight
  async updateFight(fightId, fightData) {
    const docRef = doc(db, 'fights', fightId);
    await updateDoc(docRef, {
      ...fightData,
      updatedAt: new Date()
    });
  },

  // Delete fight and all related votes
  async deleteFight(fightId) {
    // Delete all votes for this fight first
    const votesQuery = query(
      collection(db, 'votes'),
      where('fightId', '==', fightId)
    );
    const votesSnapshot = await getDocs(votesQuery);
    const voteDeletePromises = votesSnapshot.docs.map(doc => deleteDoc(doc.ref));
    await Promise.all(voteDeletePromises);

    // Then delete the fight itself
    const docRef = doc(db, 'fights', fightId);
    await deleteDoc(docRef);
  },

  // Update fight status
  async updateFightStatus(fightId, status, currentRound) {
    await this.updateFight(fightId, {
      status,
      currentRound: currentRound || null
    });
  },

  // Reorder fights
  async reorderFights(eventId, fightIds) {
    const batch = [];

    for (let i = 0; i < fightIds.length; i++) {
      const fightId = fightIds[i];
      batch.push(this.updateFight(fightId, { order: i }));
    }

    await Promise.all(batch);
  },

  // Add fight to event
  // Note: This now requires a DataStore instance to get existing fights and fighters
  async addFightToEvent(eventId, fightData, dataStore) {
    // Get current fights to determine order
    const existingFights = dataStore ? dataStore.getFightsForEvent(eventId) : [];
    const nextOrder = existingFights.length;

    // Create or get fighter references
    let fighter1Id, fighter2Id;

    if (typeof fightData.fighter1 === 'object') {
      const fighter1 = await fighterService.getOrCreateFighter({
        name: fightData.fighter1.name,
        record: fightData.fighter1.record,
        weightClass: fightData.fighter1.weightClass
      }, dataStore);
      fighter1Id = fighter1.id;
    } else {
      fighter1Id = fightData.fighter1; // Already an ID
    }

    if (typeof fightData.fighter2 === 'object') {
      const fighter2 = await fighterService.getOrCreateFighter({
        name: fightData.fighter2.name,
        record: fightData.fighter2.record,
        weightClass: fightData.fighter2.weightClass
      }, dataStore);
      fighter2Id = fighter2.id;
    } else {
      fighter2Id = fightData.fighter2; // Already an ID
    }

    const newFight = {
      eventId,
      fighter1Id,
      fighter2Id,
      weightClass: fightData.weightClass,
      rounds: fightData.rounds,
      status: fightData.status || 'upcoming',
      order: nextOrder,
      currentRound: null
    };

    return await this.createFight(newFight);
  },

};
